/**
 * Copy for the offer card's tariff details.
 *
 * The consumer funnel's equivalent (same field name in `libs/cms-sanity-schema`):
 * - `totalsExplanation` → `tariffDescriptionText` (consumer offer card, `productDetails.tariffDescription`).
 *   The consumer also has a Time-of-Use variant of this text; the SME flow offers no Time-of-Use product, so
 *   only the standard text applies.
 */
export const tariffDetailsOverviewCopy = {
  totalsExplanation:
    'Totaal, inclusief alle kosten. Op basis van het jaarverbruik. Het maandelijks termijnbedrag berekenen we door de totale jaarlijkse kosten door twaalf te delen.',
};
